<a [routerLink]="['/dashboard']" title="Dashboard" class="hdr-btn">
  <span>
    <i class="fa fa-user mr-1" aria-hidden="true"></i>
    {{ displayName }}
  </span>
</a>
